import React, { useState, useRef } from "react";
import jsPDF from "jspdf";
import axios from "axios";
import html2canvas from "html2canvas";

import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import { BASE_URL } from "../Apis/apiConfig";

export default function SocietyBatchBills() {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState({ current: 0, total: 0 });
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [flats, setFlats] = useState([]);
  const [societyInfo, setSocietyInfo] = useState(null);
  const billRef = useRef(null);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const currentFlat = flats?.[progress.current] || null;
  const [selectedBills, setSelectedBills] = useState([]);

  const toNumber = (val) => {
    const n = Number(val);
    return isNaN(n) ? 0 : n;
  };

  const getChargeRows = () => {
    if (!currentFlat) return [];

    return Object.entries(currentFlat)
  
      .filter(([key, value]) => {
        const lowerKey = key.toLowerCase();

        // remove metadata fields
        const excluded = [
          "id",
          "owner",
          "flatno",
          "flat_no",
          "billno",
          "bill_no",
          "billdate",
          "duedate",
          "date",
          "created",
          "updated",
        ];

        if (excluded.includes(lowerKey)) return false;
        return !isNaN(Number(value));
      })
      .map(([key, value]) => ({
        label: key.replaceAll("_", " ").toUpperCase(),
        value: toNumber(value),
      }));
  };

  const total = getChargeRows().reduce((sum, item) => sum + item.value, 0);


  const generatePDF = async (flat) => {
    const canvas = await html2canvas(billRef.current, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(`Bill_${flat?.flatNo || "flat"}.pdf`);
  };

  // ✅ API CALL
  const generateAllBills = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token");
      const societyName = localStorage.getItem("society");

      const response = await axios.post(
        `${BASE_URL}/bluk-generate-bill/get-bluk-generate-Bill`,
        null,
        {
          params: { societyName },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const bills = response.data?.dynamicBillDtos || [];
      setSocietyInfo(response.data?.societyDTO || null);

     const interestList = response.data?.memberInterestChargesDTOS || [];

const mapped = bills.map((item) => {
  const interestRecord = interestList.find(
    (interest) =>
      interest.unitNo === item.charges?.unit_no
  );

  return {
    ...item.charges,
    interestAmount: interestRecord?.interestAmount || 0,
  };
});

      setFlats(mapped);

      setProgress({ current: 0, total: mapped.length });

      setProgress({
  current: 0,
  total: mapped.length,
});

      setProgress({ current: 0, total: 0 });
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };


const interestAmount = Number(currentFlat?.interestAmount || 0);

const maintenanceAmount = total;

const totalDueAmount = maintenanceAmount + interestAmount;

const toggleBillSelection = (flatNo) => {
  setSelectedBills((prev) =>
    prev.includes(flatNo)
      ? prev.filter((id) => id !== flatNo)
      : [...prev, flatNo]
  );
};

const downloadSelectedBills = async () => {
  const selectedFlats = flats.filter((flat) =>
    selectedBills.includes(flat.unit_no)
  );

  if (selectedFlats.length === 0) {
    alert("Please select at least one bill");
    return;
  }

  for (let i = 0; i < selectedFlats.length; i++) {
    const flat = selectedFlats[i];

    const index = flats.findIndex(
      (f) => f.unit_no === flat.unit_no
    );

    setProgress((prev) => ({
      ...prev,
      current: index,
    }));

    await new Promise((resolve) =>
      setTimeout(resolve, 500)
    );

    await generatePDF(flat);
  }
}; 

const selectAllBills = () => {
  setSelectedBills(flats.map((flat) => flat.unit_no));
};

const clearAllBills = () => {
  setSelectedBills([]);
};

const downloadAllBills = async () => {
  if (flats.length === 0) {
    alert("No bills available");
    return;
  }

  for (let i = 0; i < flats.length; i++) {
    const flat = flats[i];

    setProgress((prev) => ({
      ...prev,
      current: i,
    }));

    await new Promise((resolve) => setTimeout(resolve, 500));

    await generatePDF(flat);
  }
};
  return (
    <div className="app-container">
      <Header toggleSidebar={toggleSidebar} />

      <div className="main-layout">
        <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

        <main className="content-area">
          <SubHeader />
<div
  style={{
    display: "flex",
    gap: "12px",
    marginTop: "15px",
    marginBottom: "20px",
    alignItems: "center",
    flexWrap: "wrap",
  }}
>

  <label
  style={{
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontWeight: "600",
  }}
>
  <input
    type="checkbox"
    checked={selectedBills.includes(currentFlat?.unit_no)}
    onChange={() => toggleBillSelection(currentFlat?.unit_no)}
  />
  Select This Bill
</label>
  <button
    onClick={() =>
      setProgress((prev) => ({
        ...prev,
        current: Math.max(0, prev.current - 1),
      }))
    }
    disabled={progress.current === 0}
    style={{
      background: "#1565c0",
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      padding: "10px 18px",
      fontSize: "14px",
      fontWeight: "600",
      cursor: progress.current === 0 ? "not-allowed" : "pointer",
      opacity: progress.current === 0 ? 0.6 : 1,
      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      transition: "all 0.3s ease",
    }}
  >
    ⬅ Previous Bill
  </button>



  <button
    onClick={() =>
      setProgress((prev) => ({
        ...prev,
        current: Math.min(flats.length - 1, prev.current + 1),
      }))
    }
    disabled={progress.current >= flats.length - 1}
    style={{
      background: "#2e7d32",
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      padding: "10px 18px",
      fontSize: "14px",
      fontWeight: "600",
      cursor:
        progress.current >= flats.length - 1
          ? "not-allowed"
          : "pointer",
      opacity: progress.current >= flats.length - 1 ? 0.6 : 1,
      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      transition: "all 0.3s ease",
    }}
  >
    Next Bill ➡
  </button>

  <button
    onClick={() => generatePDF(currentFlat)}
    disabled={!currentFlat}
    style={{
      background: "#ff9800",
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      padding: "10px 20px",
      fontSize: "14px",
      fontWeight: "600",
      cursor: !currentFlat ? "not-allowed" : "pointer",
      opacity: !currentFlat ? 0.6 : 1,
      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      transition: "all 0.3s ease",
    }}
  >
    📥 Download Bill
  </button>

  <button
    onClick={generateAllBills}
    disabled={loading}
    style={{
      background: loading ? "#9e9e9e" : "#0d47a1",
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      padding: "10px 20px",
      fontSize: "14px",
      fontWeight: "600",
      cursor: loading ? "not-allowed" : "pointer",
      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      transition: "all 0.3s ease",
    }}
  >
    {loading
      ? `Generating ${progress.current + 1}/${progress.total}`
      : "⚡ Generate Bills"}
  </button>
  <button
  onClick={downloadSelectedBills}
  disabled={selectedBills.length === 0}
  style={{
    background: "#8e24aa",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    padding: "10px 20px",
    fontSize: "14px",
    fontWeight: "600",
    cursor:
      selectedBills.length === 0
        ? "not-allowed"
        : "pointer",
    opacity: selectedBills.length === 0 ? 0.6 : 1,
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
  }}
>
  📦 Download Selected ({selectedBills.length})
</button>
<button
  onClick={selectAllBills}
  disabled={flats.length === 0}
  style={{
    background: "#00897b",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    padding: "10px 20px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
  }}
>
  ✅ Select All
</button>

<button
  onClick={clearAllBills}
  disabled={selectedBills.length === 0}
  style={{
    background: "#e53935",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    padding: "10px 20px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    opacity: selectedBills.length === 0 ? 0.6 : 1,
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
  }}
>
  ❌ Clear Selection
</button>

<button
  onClick={downloadAllBills}
  disabled={flats.length === 0}
  style={{
    background: "#6a1b9a",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    padding: "10px 20px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
  }}
>
  📥 Download All Bills
</button>

  <div
    style={{
      marginLeft: "10px",
      padding: "8px 14px",
      background: "#f5f7fa",
      borderRadius: "8px",
      border: "1px solid #d9d9d9",
      fontWeight: "600",
      color: "#0d47a1",
    }}
  >
Bill {progress.current + 1} of {flats.length}
&nbsp; | &nbsp;
Selected: {selectedBills.length}
  </div>
</div>

{flats.length > 0 && (
  <div style={{ marginBottom: "10px", fontWeight: "bold" }}>
   Bill {progress.current + 1} of {flats.length}
&nbsp; | &nbsp;
Selected: {selectedBills.length}
  </div>
)}
          {/* BILL */}
<div
  ref={billRef}
  style={{
    width: "800px",
    background: "#fff",
    padding: "35px",
    fontFamily: "Arial, sans-serif",
    color: "#333",
    border: "2px solid #0d47a1",
    marginTop: "20px",
    boxSizing: "border-box",
  }}
>
  {/* HEADER */}
<div
  style={{
    marginTop: "12px",
    fontSize: "12px",
    lineHeight: "20px",
    textAlign: "center",
  }}
>
  <h4  style={{
    color: "#0d47a1",
    fontWeight: "bold",
    margin: 0,
  }}>{localStorage.getItem('society')}</h4>
  {/* Line 1 */}
  <div>
    <b>Registration No:</b> {societyInfo?.societyRegistrationNo} &nbsp; | &nbsp;
    <b>RERA No:</b> {societyInfo?.reraRegistrationNo} &nbsp; | &nbsp;
    <b>Contact:</b> {societyInfo?.contactPersonPhoneNo}
  </div>

  {/* Line 2 */}
  <div>
    <b>Email:</b> {societyInfo?.societyEmail} &nbsp; | &nbsp;
    <b>Contact Person:</b> {societyInfo?.contactPerson}
  </div>

  {/* Line 3 */}
  <div>
    <b>Address:</b>{" "}
    {societyInfo?.societyAddress}
    {societyInfo?.societyAddress2 ? `, ${societyInfo.societyAddress2}` : ""}
    {societyInfo?.societyAddress3 ? `, ${societyInfo.societyAddress3}` : ""}
    {societyInfo?.societyArea ? `, ${societyInfo.societyArea}` : ""}
    {societyInfo?.state ? `, ${societyInfo.state}` : ""}
    {societyInfo?.pinCode ? ` - ${societyInfo.pinCode}` : ""}
  </div>
</div>

  {/* MEMBER + BILL DETAILS */}
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      gap: "20px",
      marginBottom: "25px",
    }}
  >
    <div
      style={{
        flex: 1,
        border: "1px solid #d9d9d9",
        borderRadius: "5px",
        padding: "15px",
      }}
    >
      <h3
        style={{
          margin: 0,
          marginBottom: "12px",
          color: "#0d47a1",
        }}
      >
        Member Details
      </h3>

      <div style={{ marginBottom: "8px" }}>
        <b>Name :</b>{" "}
        {currentFlat?.member_name || "-"}
      </div>

      <div>
        <b>Flat No :</b>{" "}
        {currentFlat?.unit_no || "-"}
      </div>
    </div>

    <div
      style={{
        width: "280px",
        border: "1px solid #d9d9d9",
        borderRadius: "5px",
        padding: "15px",
      }}
    >
      <h3
        style={{
          margin: 0,
          marginBottom: "12px",
          color: "#0d47a1",
        }}
      >
        Bill Details
      </h3>

      <div style={{ marginBottom: "8px" }}>
        <b>Bill No :</b>{" "}
        {currentFlat?.bill_no || "-"}
      </div>

      <div style={{ marginBottom: "8px" }}>
        <b>Bill Date :</b>{" "}
        {currentFlat?.bill_date || "-"}
      </div>

      <div>
        <b>Due Date :</b>{" "}
        {currentFlat?.due_date || "-"}
      </div>
    </div>
  </div>

  {/* TABLE */}
  <table
    style={{
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "10px",
    }}
  >
    <thead>
      <tr
        style={{
          backgroundColor: "#0d47a1",
          color: "#fff",
        }}
      >
        <th
          style={{
            border: "1px solid #ccc",
            padding: "10px",
            width: "60px",
          }}
        >
          Sr.
        </th>

        <th
          style={{
            border: "1px solid #ccc",
            padding: "10px",
            textAlign: "left",
          }}
        >
          Particulars
        </th>

        <th
          style={{
            border: "1px solid #ccc",
            padding: "10px",
            width: "180px",
          }}
        >
          Amount (₹)
        </th>
      </tr>
    </thead>

    <tbody>
      {getChargeRows().map((item, index) => (
        <tr key={index}>
          <td
            style={{
              border: "1px solid #ddd",
              padding: "8px",
              textAlign: "center",
            }}
          >
            {index + 1}
          </td>

          <td
            style={{
              border: "1px solid #ddd",
              padding: "8px",
            }}
          >
            {item.label}
          </td>

          <td
            style={{
              border: "1px solid #ddd",
              padding: "8px",
              textAlign: "right",
            }}
          >
            ₹{" "}
            {item.value.toLocaleString("en-IN", {
              minimumFractionDigits: 2,
            })}
          </td>
        </tr>
      ))}
    </tbody>
  </table>

  {/* TOTAL */}
  {/* <div
    style={{
      display: "flex",
      justifyContent: "flex-end",
      marginTop: "20px",
    }}
  >
    <div
      style={{
        background: "#0d47a1",
        color: "#fff",
        padding: "12px 25px",
        borderRadius: "4px",
        fontSize: "20px",
        fontWeight: "bold",
      }}
    >
      TOTAL : ₹{" "}
      {total.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
      })}
    </div> */}
 {/* TOTAL */}
   <div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "20px",
  }}
>
  <div
    style={{
      width: "320px",
      border: "1px solid #0d47a1",
      borderRadius: "4px",
      overflow: "hidden",
    }}
  >
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "10px",
        borderBottom: "1px solid #ddd",
      }}
    >
      <span>Maintenance Amount</span>
      <span>
        ₹ {maintenanceAmount.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
        })}
      </span>
    </div>

    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "10px",
        borderBottom: "1px solid #ddd",
      }}
    >
      <span>Interest Amount</span>
      <span>
        ₹ {interestAmount.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
        })}
      </span>
    </div>

    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "12px",
        background: "#0d47a1",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "18px",
      }}
    >
      <span>Total Due Amount</span>
      <span>
        ₹ {totalDueAmount.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
        })}
      </span>
    </div>
  </div>
</div>

  {/* FOOTER */}
  <div
    style={{
      marginTop: "60px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-end",
    }}
  >
    <div
      style={{
        fontSize: "12px",
        color: "#666",
        width: "60%",
      }}
    >
      This is a computer generated maintenance bill
      and does not require a physical signature.
    </div>

    <div style={{ textAlign: "center" }}>
      <div
        style={{
          width: "180px",
          borderTop: "1px solid #000",
          marginBottom: "5px",
        }}
      />

      <b>Authorized Signatory</b>
    </div>
  </div>
</div>
        </main>
      </div>
    </div>
  );
}